module.exports = __webpack_public_path__ + "static/img/zbank.fd62806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/zbank.png
// module id = tYxo
// module chunks = 93